export default "__VITE_ASSET__Bfhs_W6n__"